import * as h from '../helpers/helpers';
import * as rf from "./reportFunctions";

export function SubjectPropertyRentalInformationList() {
	let list = [];

	let rentControlDescription = "";
	let bRentControl = false;

	for (var improvement of global.ptr.subDwellingList) {
		rentControlDescription = h.addWithSpace(rentControlDescription, improvement.structure.structureDetail.rentControlDescription);
		for (var propertyUnit of improvement.propertyUnits) {
			if ((propertyUnit.propertyUnitDetail.unitIncludedInRentScheduleIndicator ?? false)) {
				var schedule = propertyUnit.unitRentSchedule;
				var bRented = schedule.unitRentedIndicator ?? false;
				var bMonthToMonth = schedule.monthToMonthLeaseIndicator ?? false;

				bRentControl |= !(schedule.rentControlStatusType === "No"); // Yes, No, Likely
				var propNo = propertyUnit.propertyUnitDetail.unitIdentifier;
				var rent = bRented ? schedule.unitMonthlyActualRentAmount.ToDollarAmount() : "$0";

				let row1 = [];
				row1.push(propNo);
				row1.push(h.yesNo(schedule.unitRentedIndicator));
				row1.push(h.toEnumText(propertyUnit.propertyUnitDetail.unitOccupancyType));
				row1.push(rent);
				row1.push(h.yesNo(bRented ? schedule.monthToMonthLeaseIndicator : ""));
				row1.push(!bMonthToMonth ? schedule.leaseStartDate.FormatMDY() : "");
				row1.push(h.toEnumText(schedule.rentControlStatusType));
				row1.push(bRented ? h.yesNo(schedule.financialRentalConcessionIndicator) : "");
				row1.push(bRented ? h.yesNo(schedule.unitChargesIncludeUtilitiesIndicator) : "");
				row1.push(bRented ? h.yesNo(schedule.unitFurnishedIndicator) : "");
				list.push(row1);
			}
		}
	}
	global.ptr.rentControlDescription = rentControlDescription;
	global.ptr.bRentControl = bRentControl;

	return list;
}

export function RentalInfoActualIncomeRent() {
	let list = [];
	global.ptr.rentActualIncomeRentTotal = 0;
	for (var improvement of global.ptr.subDwellingList)
		for (var propertyUnit of improvement.propertyUnits) {
			var schedule = propertyUnit.unitRentSchedule;
			let propNo = propertyUnit.propertyUnitDetail.unitIdentifier;
			let rent = schedule.unitMonthlyActualRentAmount;
			global.ptr.rentActualIncomeRentTotal += rent.Value;

			let row1 = [];
			row1.push(propNo);
			row1.push(rent.ToDollarAmount());
			list.push(row1);
		}

	return list;
}

export function RentalInfoActualIncomeOther() {
	let list = [];
	global.ptr.rentActualIncomeOtherTotal = 0;

	for (let ari of global.ptr.subProp.rentalInformationSummary.additionalRentalIncomes) {
		let rent = ari.monthlyActualAdditionalIncomeAmount;
		global.ptr.rentActualIncomeOtherTotal += rent.Value;

		let row1 = [];
		row1.push(ari.GetIncomeType());
		row1.push(rent.ToDollarAmount());
		list.push(row1);
	}

	return list;
}

export function RentalInfoOpinionOfIncomeRent() {
	let list = [];
	global.ptr.rentOpinionOfIncomeRentTotal = 0;

	for (var improvement of global.ptr.subDwellingList)
		for (var propertyUnit of improvement.propertyUnits) {
			var schedule = propertyUnit.unitRentSchedule;
			let propNo = propertyUnit.propertyUnitDetail.unitIdentifier;
			let rent = schedule.unitMonthlyMarketRentAmount;
			global.ptr.rentOpinionOfIncomeRentTotal += rent.Value;

			let row1 = [];
			row1.push(propNo);
			row1.push(rent.ToDollarAmount());
			list.push(row1);
		}

	return list;
}

export function RentalInfoOpinionOfIncomeOther() {
	let list = [];
	global.ptr.rentOpinionOfIncomeOtherTotal = 0;

	for (let ari of global.ptr.subProp.rentalInformationSummary.additionalRentalIncomes) {
		let rent = ari.monthlyEstimatedAdditionalIncomeAmount;
		global.ptr.rentOpinionOfIncomeOtherTotal += rent.Value;

		let row1 = [];
		row1.push(ari.GetIncomeType());
		row1.push(rent.ToDollarAmount());
		list.push(row1);
	}

	return list;
}

//	We collect the data in a top array containing the data for each Subject Unit
//	[[Subject Unit 1], [Subject Unit 2], ...]
//
//	For each Subject Unit we collect the row items
//	[[Row Title], [Subject Unit], [Comps 1], [Comps 2], [Comps 3], ...]
//
//	For each row we collect the ID and the individual data items
//	[[ID], [Proximity], [Neighborhood Name], ...]	

// Collect the comp rental information for each sub property
var subRentUnits = [];
var subRentalComps = [];
var subRentalCompImprovs = [];
var subRentalCompUnits = [];
var subRentalCompInformations = [];

export function CollectComparableRentalAnalysis() {
	subRentUnits = [];
	subRentalComps = [];
	subRentalCompImprovs = [];
	subRentalCompUnits = [];
	subRentalCompInformations = [];

	// first we need to determine if there is more than one unit in the subject property
	// this is total units, not units per improvement
	// collect all PropertyUnits that have UnitIncludedInRentScheduleIndicator set

	for (let i of global.ptr.subImprovs.improvementList) {
		for (let  pu of i.propertyUnits) {
			if (pu.propertyUnitDetail.unitIncludedInRentScheduleIndicator ?? false) {
				subRentUnits.push(pu);
			}
		}
	}
	//console.log(subRentUnits);

	// Now we have to figure out the mapping between the subject units and the rental comparison units
	// The mapping is between the rental comparison property unit and the subject property unit
	// *** right now I assume there is only ONE RentalInformation item in each subject property unit

	let puIndex = 0;
	for (const pu of subRentUnits) {
		subRentalComps.push([]);
		subRentalCompImprovs.push([]);
		subRentalCompUnits.push([]);
		subRentalCompInformations.push([]);

		const riLabel = pu.rentalInformations[0].label;
		// Get the related rental comps
		const subRels = global.ptr.relationships.GetRelationshipsTo("RENTAL_INFORMATION_IsComparableFor_RENTAL_INFORMATION", riLabel);

		for (const rel of subRels) {
			const compProp = global.ptr.valuationAnalysis.rentalComparables.GetComparableRentalByInformationLabel(rel);
			subRentalComps[puIndex].push(compProp);

			const compImprov = compProp.GetImprovementByInformationLabel(rel);
			subRentalCompImprovs[puIndex].push(compImprov);

			const compPU = compProp.GetPropertyUnitByInformationLabel(rel);
			subRentalCompUnits[puIndex].push(compPU);

			const compInfo = compProp.GetRentalInformationByInformationLabel(rel);
			subRentalCompInformations[puIndex].push(compInfo);
		}

		puIndex++;
	}
}

export function ComparableRentalProperties() {
	CollectComparableRentalAnalysis();

	let list = [];

	var subRiAdr = global.ptr.subProp.address.GetFullAddress();
	let item = "<b>Subject Property</b>\n" + subRiAdr;
	list.push(item);

	for (const cp of global.ptr.compRentList) {
		let sched = cp.GetUnitRentSchedule();
		let lsd = sched ? sched.leaseStartDate.FormatMDY() : "Unknown";
		let actRent = sched ? sched.unitMonthlyActualRentAmount.ToDollarAmount() : "Unknown";
		let ordinal = cp.comparable.comparableDetail.propertyOrdinalNumber;
		let comp = "<b>Comparable # " + ordinal.toString() + "</b>\n"

		let item = comp;
		item += cp.address.GetFullAddress();
		item += "\n\n<b>Data Source:</b>\n"
		item += rf.GetDataSources("DATA_SOURCE_IsDataSourceFor_PROPERTY", cp.label);
		item += "\n\n<b>Lease Start Date:</b>\n"
		item += lsd;
		item += "\n\n<b>Actual Rent:  </b>" + actRent + "\n"

		list.push(item);
	}


	return list;
}

export function ComparableRentalPropertiesImages() {
	let list = [];
	var image = global.ptr.subProp.GetImageByCategory("PropertyPhoto");
	list.push(image);
	for (const cp of global.ptr.compRentList) {
		image = cp.GetImageByCategory("PropertyPhoto");
		list.push(image);
	}
	return list;
}


//  ***************************************************************************

let masterList = [];

function rowIsEmpty(row) {
	for (let ix = 2; ix < row.length; ++ix) {
		let item = row[ix]
		if (!h.isEmpty(item) && item !== "--") return false;
	}
	return true;
}

function isRowEmpty(iy) {

	let empty = true;
	// for each improvement
	masterList.forEach(dwel => {
		let row = dwel[iy];
		empty &&= rowIsEmpty(row); 
	})

	return empty;
}

function removeRow(ix) {
	//console.log("Removing row:", ix);
	masterList.forEach(dwel => {
		dwel.splice(ix, 1);
	})
}

function removeEmptyRows() {
	let numRows = masterList[0,0].length;
	for (let ix = numRows-1; ix >= 0; --ix) {
		if (isRowEmpty(ix)) {
			removeRow(ix);
		}
	}

}

export function ComparableRentalAnalysis() {
//  Next we have to collect each of the unit comparisons into groups of one or two for display
//

//	First we need to make a list of lists

	masterList = [];
	for ( let ix = 0; ix < subRentUnits.length; ++ix ) {
		let list1 = RentalAnalysisList(
			subRentUnits[ix],
			subRentalComps[ix],
			subRentalCompImprovs[ix],
			subRentalCompUnits[ix],
			subRentalCompInformations[ix]
		);
		masterList.push(list1);
	}

//	Now we need to eliminate rows with no comp data

	removeEmptyRows();

//  [ [[1]], [[2],[3]], [[4]], [[5]] ]
//	1 is on it's own page
//	2 and 3 are on a sigle page, side by side
//	4 and 5 are each on their own page

	let list = [];
	if (subRentUnits.length === 1) {
		// only one, keep it simple
		let list0 = [];
		let list1 = masterList[0];
		list0.push(list1);
		list.push(list0);
	} else {
		let numUnits = subRentUnits.length;
		let ruix = 0;
		while( ruix < numUnits ) {
			let numComps = subRentalComps[ruix].length;
			if (numComps > 3 || ruix === numUnits-1) {
				// if there are more than 3 comps, display on own page
				// or if the last one, display it
				let list0 = [];
				let list1 = masterList[ruix];
				list0.push(list1);
				list.push(list0);
				++ruix;
			} else if (subRentalComps[ruix+1].length < 4 ) {
				// this one can't be the last one so see if the next will fit on the same page
				let list0 = [];
				let list1 = masterList[ruix];
				list0.push(list1);
				let list2 = masterList[ruix+1];
				list0.push(list2);
				list.push(list0);
				ruix += 2;
			}
		}

	}
	//console.log(list);
	return list;	
}


function RentalAnalysisList(subRentUnits, subRentalComps, subRentalCompImprovs,	subRentalCompUnits,	subRentalCompInformations) {
	let list = [];

	list.push(CompRentHeader(subRentUnits, subRentalComps));
	list.push(CompRentProximity(subRentalComps));
	list.push(CompRentProjectName(subRentalComps));
	list.push(CompRentAmenities(subRentalCompInformations));
	list.push(CompRentSiteInfluence(subRentalCompInformations));
	list.push(CompRentView(subRentalCompInformations));
	list.push(CompRentSiteSize(subRentalComps));
	list.push(CompRentInteriorCondition(subRentUnits, subRentalCompUnits));
	list.push(CompRentBedrooms(subRentUnits, subRentalCompUnits));
	list.push(CompRentBathrooms(subRentUnits, subRentalCompUnits));
	list.push(CompRentFinishedArea(subRentUnits, subRentalCompUnits));
	list.push(CompRentFurnished(subRentUnits, subRentalCompUnits));
	list.push(CompRentUtilitiesIncluded(subRentUnits, subRentalCompUnits));
	list.push(CompRentRentControl(subRentUnits, subRentalCompUnits));
	list.push(CompRentRentConcessions(subRentUnits, subRentalCompUnits));
	list.push(CompRentVehicleStorage(subRentUnits, subRentalCompInformations));
	list.push(CompRentSummary(subRentalComps.length));
	list.push(CompRentRentPerFinishedArea(subRentUnits, subRentalCompUnits));
	list.push(CompRentActualRent(subRentUnits, subRentalCompUnits));
	list.push(CompRentComparisonToSubject(subRentalCompInformations));
	list.push(CompRentAdjustedRent(subRentalCompInformations));
	list.push(CompRentMarketRent(subRentUnits, subRentalComps.length));
	list.push(CompRentComparableWeight(subRentalCompInformations));

	return list;
}

function CompRentHeader(sp, rc) {
	let list = [];
	list.push("Header");
	list.push("Subject\n" + sp.propertyUnitDetail.unitIdentifier);

	rc.forEach(c => {
		list.push(c.comparable.comparableDetail.propertyOrdinalNumber);
	})
	return list;
	}

function CompRentProximity(comps) {
	let list = [];
	list.push("Proximity to Subject");
	list.push("GRAY");
	//console.log("COMPS", comps);
	comps.forEach(cp => {
		//console.log("CP", cp);
		list.push(cp.comparable.GetProximity());
	})
	return list;
	}

function CompRentProjectName(comps) {
	let list = [];
	list.push("Project Name");
	if (!global.ptr.subProj) {
			list.push(...emptyList(comps))
	 		return list;
	}

	list.push(global.ptr.subProj.projectDetail.projectName);
	comps.forEach(cp => {
		list.push(cp.project.projectDetail.projectName);
	})
	return list;
}

function CompRentAmenities(r) {
	const list = [];
	list.push("Project Common\nAmenities/Services");
	if (!global.ptr.subProj) {
			list.push(...emptyList(r))
	 		return list;
	}

	let amen = global.ptr.subProj.GetAmenities("\n| ");
	list.push(amen);
	
	r.forEach(ri => {
		list.push(ri.rentalComparison.rentalComparisonDetail.amenitiesComparisonType);
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentSiteInfluence(r) {
	const list = [];
	list.push("Site Influence");
	let inf = global.ptr.subSite.GetInfluence();
	inf = inf.replaceAll(" | ", "\n| ");
	list.push(inf);

	r.forEach(ri => {
		list.push(ri.rentalComparison.rentalComparisonDetail.siteInfluencesComparisonType);
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentView(r) {
	const count = r.length;
	const list = [];
	list.push("View from Unit");
	let inf = global.ptr.subSite.GetView();
	inf = inf.replaceAll(" | ", "\n| ");
	list.push(inf);

	r.forEach(ri=> {
		list.push(h.toEnumText(ri.rentalComparison.rentalComparisonDetail.viewsComparisonType));
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentSiteSize(cr) {
	const list = [];
	list.push("Site Size");
	if (global.ptr.subSite.siteSizeLayout == null) return list;

	list.push(global.ptr.subSite.siteSizeLayout.lotSizeAreaMeasure.ToString());

	cr.forEach(c => { 
		if (c.site.siteSizeLayout)
		 	list.push(c.site.siteSizeLayout.lotSizeAreaMeasure.ToString());
		else
			list.push("");
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentInteriorCondition(sp, cp) {
	const list = [];
	list.push("Interior Condition");
	list.push(sp.propertyUnitDetail.interiorConditionRatingCode);

	cp.forEach(c => {
		list.push(c.propertyUnitDetail.interiorConditionRatingCode);
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentBedrooms(sp, cp) {
	const list = [];
	list.push("Bedrooms");
	list.push(sp.propertyUnitDetail.bedroomCount.toString());

	cp.forEach(c => {
		list.push(c.propertyUnitDetail.bedroomCount.toString());
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentBathrooms(sp, cp) {
	const list = [];
	list.push("Baths - Full | Half");
	list.push(sp.GetBathrooms());

	cp.forEach(c => {
		list.push(c.GetBathrooms());
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentFinishedArea(sp, cp) {
	const list = [];
	list.push("Finished Area");
	list.push(sp.propertyUnitArea.unitTotalFinishedAreaMeasure.ToString());

	cp.forEach(c => {
		list.push(c.propertyUnitArea.unitTotalFinishedAreaMeasure.ToString());
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentFurnished(sp, cp) {
	const list = [];
	list.push("Furnished");
	list.push(h.yesDashes(sp.unitRentSchedule.unitFurnishedIndicator));

	cp.forEach(c => {
		list.push(h.yesDashes(c.unitRentSchedule.unitFurnishedIndicator));
	});

	if (rentCompEmpty(list)) return [];
	return list;
}
function CompRentUtilitiesIncluded(sp, cp) {
	const list = [];
	list.push("Utilities/Services\nIncluded");
	list.push(h.yesDashes(sp.unitRentSchedule.unitChargesIncludeUtilitiesIndicator));

	cp.forEach(c => {
		list.push(h.yesNo(c.unitRentSchedule.unitChargesIncludeUtilitiesIndicator));
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentRentControl(sp, cp) {
	const list = [];
	list.push("Rent Control");
	list.push(sp.unitRentSchedule.rentControlStatusType);
	
	cp.forEach(c => {
		list.push(c.unitRentSchedule.rentControlStatusType);
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentRentConcessions(sp, cp) {
	const list = [];
	list.push("Rent Concessions");
	list.push(h.yesNoDashes(sp.unitRentSchedule.financialRentalConcessionIndicator));

	cp.forEach(c => {
		list.push(h.yesNoDashes(c.unitRentSchedule.financialRentalConcessionIndicator));
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentVehicleStorage(subPU, ri) {
	const list = [];
	list.push("Vehicle Storage | Spaces");
	list.push(subPU.rentalInformations[0].GetVehicleStorageSpaces());

	ri.forEach(r => {
		list.push(r.rentalComparison.rentalComparisonDetail.carStoragesComparisonType);
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentSummary(count) {
	const list = [];
	list.push("Summary");
	for (let i = 0; i < count + 1; ++i) {
		list.push("EMPTY");
	};

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentRentPerFinishedArea(sp, cr) {
	const list = [];
	list.push("!Rent Per Finished Area");
	list.push(h.toDollarAndCentsAmount(sp.unitRentSchedule.actualRentPerUnitFinishedAreaAmount));

	cr.forEach(c => {
		list.push(h.toDollarAndCentsAmount(c.unitRentSchedule.actualRentPerUnitFinishedAreaAmount));
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentActualRent(sp, cr) {
	const list = [];
	list.push("!Actual Rent");
	list.push(h.amountOrEmpty(sp.unitRentSchedule.unitMonthlyActualRentAmount));

	cr.forEach(c => {
		list.push(h.amountOrEmpty(c.unitRentSchedule.unitMonthlyActualRentAmount));
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentComparisonToSubject(ri) {
	const list = [];
	list.push("!Overall Comparison\nTo Subject");
	list.push("GRAY");

	ri.forEach(r => {
		list.push(r.rentalComparison.rentalComparisonDetail.rentalUnitToSubjectComparisonType);
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentAdjustedRent(ri) {
	const list = [];
	list.push("!Adjusted Rent");
	list.push("GRAY");

	ri.forEach(r => {
		list.push(h.amountOrEmpty(r.rentalComparison.rentalComparisonDetail.rentalUnitAdjustedRentAmount));
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentMarketRent(sp, count) {
	const list = [];
	list.push("!Opinion of\nMarket Rent");
	list.push(h.amountOrEmpty(sp.unitRentSchedule.unitMonthlyMarketRentAmount));

	for (let i = 0; i < count; ++i) {
		list.push("GRAY");
	};

	if (rentCompEmpty(list)) return [];
	return list;
}

function CompRentComparableWeight(ri) {
	const list = [];
	list.push("!Comparable Weight");
	list.push("GRAY");

	ri.forEach(r => {
		list.push(r.rentalComparison.rentalComparisonDetail.comparableWeightType);
	});

	if (rentCompEmpty(list)) return [];
	return list;
}

function rentCompEmpty() {
	return false;
}

function emptyList(comps) {
	let list = [];
	list.push("")
	for (let cp of comps) list.push("");
	return list;
}

export function RentalInformationExhibits() {
	let images = [];
	images.push(global.ptr.subProp.GetImageByCategory("RentalComparableMap"));
	
	let ix = 1;
	global.ptr.compRentList.forEach(cm => {
		let cmImage = cm.GetImageByCategory("PropertyPhoto");
		cmImage.imageSourceCaption = "Comparable #" + (ix).toString();
		images.push(cmImage);
		++ix;
	});
	
	// other stuff
	images.push(...global.ptr.subProp.GetImagesByCategory("RentalInformationExhibit"));

	return images;
}

